module.exports = __webpack_public_path__ + "static/media/screen_two.16b50e62.png";